/* PDP desktop layout.
 *
 * The long-form marketing stack (.pdp-marketing-media) is authored inside the
 * right-hand info column, which is right for mobile — it reads as one column
 * there.  At desktop it left the media column ending at ~680px while the info
 * column ran past 8,000px.  the reference site keeps its long-form media on the left
 * beside a short buy box, so from 990px up we move the stack into the media
 * column and put it back below that.
 *
 * Pure DOM reparenting, no style changes: the block keeps its own CSS, and the
 * mobile layout is byte-for-byte what it was.
 */
(function () {
  var MQ = '(min-width: 990px)';

  function apply(mql) {
    var stack = document.querySelector('.pdp-marketing-media');
    if (!stack) return;

    var mediaCol = document.querySelector('.product__media-wrapper');
    var infoCol = document.querySelector('.product__info-container');
    if (!mediaCol || !infoCol) return;

    // Remember where it started so we can put it back exactly.
    if (!stack.__homeParent) {
      stack.__homeParent = stack.parentElement;
      stack.__homeNext = stack.nextElementSibling;
    }

    if (mql.matches) {
      if (stack.parentElement !== mediaCol) mediaCol.appendChild(stack);
    } else if (stack.parentElement !== stack.__homeParent) {
      stack.__homeParent.insertBefore(stack, stack.__homeNext);
    }
  }

  /* With the long-form media on the left, the buy column is ~2,300px against an
   * ~8,300px media column, so it would sit in six thousand pixels of white space.
   * Stick it — but it is taller than the viewport, so pinning its top would put
   * the accordions permanently out of reach.  Offset the sticky top by its own
   * overflow instead: it scrolls normally until its bottom meets the bottom of
   * the viewport, then holds there for the rest of the media column. */
  function stickyInfo(mql) {
    var info = document.querySelector('.product__info-wrapper');
    if (!info) return;

    if (!mql.matches) {
      info.style.position = '';
      info.style.top = '';
      info.style.alignSelf = '';
      return;
    }

    var h = info.getBoundingClientRect().height;
    var vh = window.innerHeight;
    var GAP = 24;
    var top = h + GAP > vh ? Math.round(vh - h - GAP) : 100;

    info.style.position = 'sticky';
    info.style.top = top + 'px';
    info.style.alignSelf = 'flex-start';
  }

  function init() {
    var mql = window.matchMedia(MQ);
    apply(mql);
    stickyInfo(mql);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { stickyInfo(mql); }, 150);
    });
    /* the accordions change the column height when opened */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.product__info-wrapper summary, .product__info-wrapper details')) {
        setTimeout(function () { stickyInfo(mql); }, 350);
      }
    });
    function onChange() { apply(mql); stickyInfo(mql); }
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
